<template>
<div>
<vx-card no-shadow>
<vs-table ref="table"  :max-items="5" search  :data="userMeta.cardMeta" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Métodos de pago
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="nombre">Nombre</vs-th>
        <vs-th sort-key="type">Tipo de tarjeta</vs-th>
        <vs-th sort-key="digits">Últimos 4 digitos</vs-th>
        <vs-th sort-key="expiry">Fecha de expiración</vs-th>
        <vs-th></vs-th>
        <vs-th></vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="tr.id" v-for="tr in data">
              <vs-td>
                <a><p class="font-medium truncate">{{ `${tr.holderName}` }}</p></a>
              </vs-td>
              <vs-td>
                <a><p class="font-medium truncate">{{ `${tr.cardtype}`}}</p></a>
              </vs-td>

              <vs-td>
                <a class="font-medium truncate">{{ `${tr.lastDigits}`  }}</a>
              </vs-td>

              <vs-td>
                <p>{{ `${tr.expiryDate}` }}</p>
              </vs-td>

              <vs-td>
                    <vs-switch v-model="tr.active" color="success" @click="activeSwitch(tr.id)">
                        <span slot="on">Activa</span>
                        <span slot="off"></span>
                    </vs-switch>
              </vs-td>

              <vs-td>
                <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click="deleteCard(tr.id)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="mt-2 mr-6 text-right">
              <vs-button v-if="changed" class="mr-2 color:success"  @click="$modal.show('newCardModal');">Guardar cambios</vs-button>
              <vs-button  @click="$modal.show('newCardModal');">Agregar Nueva</vs-button>
    </div>
    <vs-table ref="table"  :max-items="5" :data="transactionInfo" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Transacciones
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="ID">ID</vs-th>
        <vs-th sort-key="card">Tarjeta utilizada</vs-th>
        <vs-th sort-key="digits">Últimos 4 digitos</vs-th>
        <vs-th sort-key="amount">Cantidad</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="tr.id" v-for="tr in data">
              <vs-td>
                <a><p class="font-medium truncate">{{ `${tr.id + 1}` }}</p></a>
              </vs-td>
              <vs-td>
                <a><p class="font-medium truncate">{{ `${tr.cardType}`}}</p></a>
              </vs-td>

              <vs-td>
                <a class="font-medium truncate">{{ `${tr.lastDigits}`  }}</a>
              </vs-td>

              <vs-td>
                <p>{{ `${tr.amount}` }}</p>
              </vs-td>


            </vs-tr>
          </tbody>
        </template>
    </vs-table>
</vx-card>
<modal 
    name='newCardModal'
    height='auto'
    width='60%'
    style="z-index: 1005;"
    :scrollable="true">
    <form data-vv-scope="new-card">
        <div class="vx-row my-3 ml-1">
                <div class="vx-col w-full" >
                <h2>Nueva Tarjeta</h2>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-4/4 sm:w-full w-full flex flex-col items-center" >
                  <vs-input class="w-full px-5" label="Nombre en la tarjeta" placeholder=""
                  name="nombre" v-validate="'required'" v-model="newCard.holderName"/>
                  <span class="text-danger">{{ errors.first('new-card.nombre') }}</span>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-2/3 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" maxlength="19" label="Numero de tarjeta" placeholder=""
                  name="número" v-validate="'required|alpha_dash:19'" v-model="cards"/>
                  <span class="text-danger">{{ errors.first('new-card.número') }}</span>
                </div>
                <div class="vx-col md:w-1/3 sm:w-full w-full flex flex-col items-center">
                  <vs-input maxlength="3" class="w-full px-5" label="CVV" placeholder="" 
                  name="cvv" v-validate="'required|digits:3'" v-model="cvv"/>
                  <span class="text-danger">{{ errors.first('new-card.cvv') }}</span>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" maxlength="2" label="Mes de expiración" placeholder=""
                  name="month" v-validate="'required|digits:2'" v-model="newCard.expiryMonth"/>
                  <span class="text-danger">{{ errors.first('new-card.month') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" maxlength="2" label="Año de expiración" placeholder="" 
                  name="year" v-validate="'required|digits:2'" v-model="newCard.expiryYear"/>
                  <span class="text-danger">{{ errors.first('new-card.year') }}</span>
                </div>
              </div>
              <vs-divider class="mt-6 mb-5" />
              <div class="vx-row w-full mt-3">
                <div class="vx-col w-full flex flex-col items-center">
              <vs-checkbox color="success" v-model="newCard.active">Utilizar por defecto</vs-checkbox>
            </div>
            </div>  
              <div class="vx-row pt-3 pb-6">
                <div class="vx-col w-full flex justify-center">
                  <vs-button class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-credit-card"
                     @click="validateNewCard">
                    Agregar
                  </vs-button>
                </div>
              </div>
    </form>
</modal>
<modal
    name="deleteCardModal"
    height="auto"
    width="50%"
    :scrollable="true">
    <div class="vx-row my-3 ml-1">
        <h3 class="justify-center"> Desea eliminar la tarjeta con terminación {{ this.deleteDigits}}?</h3>
    
    <vs-divider class="mt-6 mb-5" />
    
    <div class="items-center flex">
        <vs-button class="px-6 inline" color="danger" type="filled"
        @click="finalDeletion">
            Eliminar
        </vs-button>
        <vs-button class="px-6  ml-5" color="primary" type="filled"
        @click="$modal.hide('deleteCardModal')">
            Cancelar
        </vs-button>    
    </div>
    </div>
</modal>
</div>
</template>

<script>
import vSelect from 'vue-select'

export default ({
    components: {
        vSelect
    },
    data () {
        return {
            cards : '',
            deleteId: null,
            changed: false,
            deleteDigits: null,
            cvv: null,
            cardInfo: [
            ],
            userData: {
                id: null,
                first_name: "",
                last_name: "",
                dob: "",
                gender: "",
                phone: [""],
                linkedin: "",
                address: "",
                address_2: "",
                zone: "",
                city: "",
                country: "",
                meta: {},
            },
            userMeta: {
                consultationLength: 60,
                cardMeta: [
                
                ],
                transactions: [

                ],
            },
            newCard: {
                id: null,
                cardNumber: null,
                lastDigits: null,
                holderName: null,
                expiryDate: null,
                expiryMonth: null,
                expiryYear: null,
                cardtype: null,
                active: false
            },
            newCardSave: {
                id: null,
                cardNumber: null,
                lastDigits: null,
                holderName: null,
                expiryDate: null,
                expiryMonth: null,
                expiryYear: null,
                cardtype: null,
                active: false
            },
            transactionInfo : 
            [{
                id: 0,
                cardId: 0,
                lastDigits: "4211",
                cardType: "MasterCard",
                description: "example description",
                amount: "999.99",
            }]

        }
    },
    methods: {
       validateNewCard () {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('new-card').then(result => {
            if (result) {
                this.newCard.cardNumber = this.cards;
                this.editUserSettingsPayment()
                resolve(true);
            } else {
                reject('correct all values')
            }
            })
        })
        },
        deleteCard (id) {
            this.$modal.show("deleteCardModal");
            this.cardInfo = this.userMeta.cardMeta
            this.deleteId = id
            this.deleteDigits = this.cardInfo[id].lastDigits
            
        },
        finalDeletion () {
            this.cardInfo.splice(this.deleteId, 1);
            this.userData.meta.cardMeta = this.cardInfo
            this.userData.meta = this.userMeta;

            this.$validator.validateAll().then((result) => {
                if (result) {
                // if form have no errors
                this.editting = !this.editting;
                // TODO editUser
                
                this.$store.dispatch("evolugy/updateUser", this.userData);
                this.showAlert(
                    "success",
                    "Tarjeta Eliminada",
                    "Métodos de pago actualizados éxitosamente!"
                );
                } else {
                console.log("errores");
                this.showAlert(
                    "danger",
                    "Error al editar los métodos de pago del usuario.",
                    error.response.data.error
                );
                // form have errors
                }
            });

            this.$modal.hide('deleteCardModal')
        },
        activeSwitch (id) {
          this.changed = true
          for (let i = 0; i < this.cardInfo.length; i++) {
              if (this.cardInfo[i].id != id && this.cardInfo[i].active == true) {
                  this.cardInfo[i].active = !this.cardInfo[i].active
              }
            }
        },
        editUserSettingsPayment () {
            this.newCard.lastDigits = this.newCard.cardNumber.slice(-4)
            if (this.newCard.cardNumber.slice(0,1) == "4") {
                this.newCard.cardtype = "Visa"
            } else {
                this.newCard.cardtype = "MasterCard"
            }
            this.newCard.expiryDate = this.newCard.expiryMonth + '/' + this.newCard.expiryYear
            this.newCard.id = this.cardInfo.length
            this.cardInfo.push(this.newCard)
            console.log(this.newCard, this.cardInfo)
            this.newCard = JSON.parse(JSON.stringify(this.newCardSave))
            this.cards = ''
            this.cvv = ''
            this.$modal.hide("newCardModal")
            console.log(this.userMeta.cardMeta, this.cardInfo) 
            this.userData.meta.cardMeta = this.cardInfo
            this.$validator.validateAll().then((result) => {
                if (result) {
                // if form have no errors
                this.editting = !this.editting;
                // TODO editUser
                
                this.$store.dispatch("evolugy/updateUser", this.userData);
                this.showAlert(
                    "success",
                    "Tarjetas Modificadas",
                    "Métodos de pago actualizados éxitosamente!"
                );
                } else {
                console.log("errores");
                this.showAlert(
                    "danger",
                    "Error al editar los métodos de pago del usuario.",
                    error.response.data.error
                );
                // form have errors
                }
            });
        }
    },
    watch: {
        cards () {
            let realNumber = this.cards.replace(/-/gi, '');

            let dashedNumber = realNumber.match(/.{1,4}/g)

            this.cards = dashedNumber.join('-')
        }
    },
    computed: {
        activeUserInfo () {
            return this.$store.state.AppActiveUser
        }
    },
    created () {
        this.userMeta = {
            ...this.userMeta,
            ...JSON.parse(JSON.stringify(this.activeUserInfo.meta)),
        };
        this.cardInfo = this.userMeta.cardMeta

        // Object data
        this.userData.first_name = this.activeUserInfo.first_name;
        this.userData.last_name = this.activeUserInfo.last_name;
        this.userData.dob = this.activeUserInfo.dob;
        this.userData.gender = this.activeUserInfo.gender;
        this.userData.phone[0] = this.activeUserInfo.phone[0];
        this.userData.linkedin = this.activeUserInfo.linkedin;
        this.userData.address = this.activeUserInfo.address;
        this.userData.address_2 = this.activeUserInfo.address_2;
        this.userData.zone = this.activeUserInfo.zone;
        this.userData.city = this.activeUserInfo.city;
        this.userData.country = this.activeUserInfo.country;
    }
});
</script>
